module.exports = __webpack_public_path__ + "assets/img/hero-financial-horizon.cb801e18.png";